<section id="home" class="slider_area">
    <div class="carousel-inner">
        <div class="carousel-item active">
            <div class="slider-content">&nbsp;</div>
        </div>
    </div>
</section>

<section id="pricing" class="compare-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-10">
                <div class="section-title text-center pb-25">
                    <h3 class="title">{{'PRICING.TITLE' | translate }}</h3>
                    <p class="text">{{'PRICING.TEXT' | translate }}</p>
                </div>
            </div>
        </div>

        <!-- Pricing Tabs -->
        <div class="pricing-tabs">
            <ul class="nav nav-tabs justify-content-center mb-4" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" data-toggle="tab" href="#start" role="tab">{{'PRICING.START_PLAN_TITLE' |
                        translate }}</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-toggle="tab" href="#smart" role="tab">{{'PRICING.SMART_PLAN_TITLE' |
                        translate }}</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-toggle="tab" href="#scale" role="tab">{{'PRICING.SCALE_PLAN_TITLE' |
                        translate }}</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-toggle="tab" href="#propero"
                        role="tab">{{'PRICING.MANAGEMENT_PROPERO_TITLE' | translate }}</a>
                </li>
            </ul>

            <div class="tab-content">
                <!-- Start Plan Tab -->
                <div class="tab-pane fade show active" id="start" role="tabpanel">
                    <div class="plan-details">
                        <div class="row">
                            <div class="col-lg-4">
                                <div class="pricing-card normal">
                                    <div class="card-header">
                                        <div class="price-icon">
                                            <img src="assets/images/payment/start.png" alt="">
                                        </div>
                                        <h3>{{'PRICING.START_PLAN_TITLE' | translate }}</h3>
                                        <div class="badge">{{'PRICING.START_TEXT' | translate }}</div>

                                        <div class="price"
                                            *ngIf="getSubscriptionPriceDetails('start_subscription_monthly') as start_subscription_monthly">
                                            {{ start_subscription_monthly?.subscriptionPrice || '0.00' }} {{
                                            start_subscription_monthly?.subscriptionCurrency || 'RON' }}
                                            {{ 'PRICING.START_PRICE' | translate }}</div>

                                        <p class="description">{{'PRICING.START_FUNCTIONALITY_TEXT' | translate }}</p>
                                    </div>
                                    <div class="card-body">
                                        <div class="title">
                                            {{'PRICING.START_ITEM_TITLE' | translate }}
                                        </div>
                                        <div class="feature">
                                            {{'PRICING.START_ITEM_FEATURE' | translate }}
                                        </div>
                                        <ul class="features-list">
                                            <li><i class="fas fa-check"></i> {{'PRICING.START_ITEM1_TEXT' | translate }}
                                            </li>
                                            <li><i class="fas fa-check"></i> {{'PRICING.START_ITEM2_TEXT' | translate }}
                                            </li>
                                            <li><i class="fas fa-check"></i> {{'PRICING.START_ITEM3_TEXT' | translate }}
                                            </li>
                                            <li><i class="fas fa-check"></i> {{'PRICING.START_ITEM4_TEXT' | translate }}
                                            </li>
                                            <li><i class="fas fa-check"></i> {{'PRICING.START_ITEM5_TEXT' | translate }}
                                            </li>
                                            <li><i class="fas fa-check"></i> {{'PRICING.START_ITEM6_TEXT' | translate }}
                                            </li>
                                        </ul>
                                        <div class="notes">
                                            <p>{{'PRICING.START_ITEM_NOTES_1' | translate }}</p>
                                            <p>{{'PRICING.START_ITEM_NOTES_2' | translate }}</p>
                                        </div>
                                    </div>
                                    <div class="card-footer">
                                        <a href="{{assistantHref}}/register"
                                            class="btn-primary">{{'PRICING.PLAN_BUTTON_START_HERE' | translate }}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-8">
                                <div class="features-table">
                                    <h4>{{'PRICING.FUNCTIONALITIES' | translate }}</h4>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <tbody>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM1_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">Start plan</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM2_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM3_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM4_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM5_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM6_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM7_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_X_1_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_X_2_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_X_3_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM10_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_NOT_1_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_NOT_2_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_NOT_3_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM12_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM13_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM14_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM16_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM17_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM18_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM20_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM21_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM22_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM24_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM25_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM27_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">
                                                            {{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                            | translate }}
                                                        </span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM29_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM30_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>

                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM32_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">
                                                            <span class="feature-value">
                                                                Management Propero
                                                            </span>
                                                        </span></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Smart Plan Tab -->
                <div class="tab-pane fade" id="smart" role="tabpanel">
                    <div class="plan-details">
                        <div class="row">
                            <div class="col-lg-4">
                                <div class="pricing-card normal">
                                    <div class="card-header">
                                        <div class="price-icon">
                                            <img src="assets/images/payment/smart.png" alt="">
                                        </div>
                                        <h3>{{'PRICING.SMART_PLAN_TITLE' | translate }}</h3>
                                        <div class="badge">{{'PRICING.SMART_PLAN_TEXT' | translate }}</div>

                                        <div class="price"
                                            *ngIf="getSubscriptionPriceDetails('smart_subscription_monthly') as smart_subscription_monthly">
                                            {{ smart_subscription_monthly?.subscriptionPrice || '0.00' }} {{
                                            smart_subscription_monthly?.subscriptionCurrency || 'RON' }}
                                            {{ 'PRICING.SMART_PRICE' | translate }}</div>

                                        <p class="description">{{'PRICING.SMART_PLAN_TEXT' | translate }}</p>
                                    </div>
                                    <div class="card-body">
                                        <div class="title">
                                            {{'PRICING.SMART_ITEM_TITLE' | translate }}
                                        </div>
                                        <div class="feature">
                                            {{'PRICING.SMART_ITEM_FEATURE' | translate }}
                                        </div>
                                        <ul class="features-list">
                                            <li><i class="fas fa-check"></i> {{'PRICING.SMART_ITEM1_TEXT' | translate }}
                                            </li>
                                            <li><i class="fas fa-check"></i> {{'PRICING.SMART_ITEM2_TEXT' | translate }}
                                            </li>
                                            <li><i class="fas fa-check"></i> {{'PRICING.SMART_ITEM3_TEXT' | translate }}
                                            </li>
                                            <li><i class="fas fa-check"></i> {{'PRICING.SMART_ITEM4_TEXT' | translate }}
                                            </li>
                                            <li><i class="fas fa-check"></i> {{'PRICING.SMART_ITEM5_TEXT' | translate }}
                                            </li>
                                            <li><i class="fas fa-check"></i> {{'PRICING.SMART_ITEM6_TEXT' | translate }}
                                            </li>
                                        </ul>
                                        <div class="notes">
                                            <p>{{'PRICING.SMART_ITEM_NOTES_1' | translate }}</p>
                                            <p>{{'PRICING.SMART_ITEM_NOTES_2' | translate }}</p>
                                        </div>
                                    </div>
                                    <div class="card-footer">
                                        <a href="{{assistantHref}}/register"
                                            class="btn-primary">{{'PRICING.PLAN_BUTTON_START_HERE' | translate }}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-8">
                                <div class="features-table">
                                    <h4>Funcționalități incluse</h4>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <tbody>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM1_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">Smart plan</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM2_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ADVANCED'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM3_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ADVANCED'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM4_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ADVANCED'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM5_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM6_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM7_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ADVANCED'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_X_1_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ADVANCED'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_X_2_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ADVANCED'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_X_3_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM10_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ADVANCED'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_NOT_1_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_NOT_2_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_NOT_3_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM12_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM13_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ADVANCED'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM14_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ADVANCED'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM16_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ADVANCED'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM17_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM18_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM20_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM21_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM22_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM24_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM25_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM27_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">
                                                            {{'PRICING.FUNCTIONALITY_OPTION_BASIC'
                                                            | translate }}
                                                        </span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM29_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM30_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>

                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM32_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">
                                                            <span class="feature-value">
                                                                Management Propero
                                                            </span>
                                                        </span></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Scale Plan Tab -->
                <div class="tab-pane fade" id="scale" role="tabpanel">
                    <div class="plan-details">
                        <div class="row">
                            <div class="col-lg-4">
                                <div class="pricing-card normal">
                                    <div class="card-header">
                                        <div class="price-icon">
                                            <img src="assets/images/payment/scale.png" alt="">
                                        </div>
                                        <h3>{{'PRICING.SCALE_PLAN_TITLE' | translate }}</h3>
                                        <div class="badge">{{'PRICING.SCALE_PLAN_TEXT' | translate }}</div>

                                        <div class="price"
                                            *ngIf="getSubscriptionPriceDetails('scale_subscription_monthly') as scale_subscription_monthly">
                                            {{ scale_subscription_monthly?.subscriptionPrice || '0.00' }} {{
                                            scale_subscription_monthly?.subscriptionCurrency || 'RON' }}
                                            {{ 'PRICING.SCALE_PRICE' | translate }}</div>

                                        <p class="description">{{'PRICING.SCALE_PLAN_TEXT' | translate }}</p>
                                    </div>
                                    <div class="card-body">
                                        <div class="title">
                                            {{'PRICING.SCALE_ITEM_TITLE' | translate }}
                                        </div>
                                        <div class="feature">
                                            {{'PRICING.SCALE_ITEM_FEATURE' | translate }}
                                        </div>
                                        <ul class="features-list">
                                            <li><i class="fas fa-check"></i> {{'PRICING.SCALE_ITEM1_TEXT' | translate }}
                                            </li>
                                            <li><i class="fas fa-check"></i> {{'PRICING.SCALE_ITEM2_TEXT' | translate }}
                                            </li>
                                            <li><i class="fas fa-check"></i> {{'PRICING.SCALE_ITEM3_TEXT' | translate }}
                                            </li>
                                            <li><i class="fas fa-check"></i> {{'PRICING.SCALE_ITEM4_TEXT' | translate }}
                                            </li>
                                            <li><i class="fas fa-check"></i> {{'PRICING.SCALE_ITEM5_TEXT' | translate }}
                                            </li>
                                            <li><i class="fas fa-check"></i> {{'PRICING.SCALE_ITEM6_TEXT' | translate }}
                                            </li>
                                        </ul>
                                        <div class="notes">
                                            <p>{{'PRICING.SCALE_ITEM_NOTES_1' | translate }}</p>
                                            <p>{{'PRICING.SCALE_ITEM_NOTES_2' | translate }}</p>
                                        </div>
                                    </div>
                                    <div class="card-footer">
                                        <a href="{{assistantHref}}/register"
                                            class="btn-primary">{{'PRICING.PLAN_BUTTON_START_HERE' | translate }}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-8">
                                <div class="features-table">
                                    <h4>{{'PRICING.SCALE_TABLE_TITLE' | translate }}</h4>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <tbody>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM1_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">Scale plan</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM2_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM3_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM4_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM5_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM6_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM7_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_X_1_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ENTERPRISE'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_X_2_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ENTERPRISE'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_X_3_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ENTERPRISE'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM10_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_NOT_1_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_NOT_2_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_NOT_3_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM12_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM13_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM14_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM16_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM17_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM18_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM20_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM21_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM22_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM24_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM25_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">-</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM27_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">
                                                            {{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                            | translate }}
                                                        </span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM29_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ENTERPRISE_ENTERPRISE'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM30_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ENTERPRISE_ENTERPRISE'
                                                        | translate }}</span></td>
                                                </tr>

                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM32_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">
                                                            <span class="feature-value">
                                                                Management Propero
                                                            </span>
                                                        </span></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Management Propero Tab -->
                <div class="tab-pane fade" id="propero" role="tabpanel">
                    <div class="plan-details">
                        <div class="row">
                            <div class="col-lg-4">
                                <div class="pricing-card premium">
                                    <div class="card-header">
                                        <div class="price-icon">
                                            <img src="assets/images/payment/premium.png" alt="">
                                        </div>
                                        <h3>{{'PRICING.MANAGEMENT_PROPERO_TITLE' | translate }}</h3>
                                        <div class="badge premium-badge">{{'PRICING.MANAGEMENT_PROPERO_TEXT' | translate
                                            }}</div>

                                        <div class="price">{{'PRICING.MANAGEMENT_PROPERO_PRICE' | translate }}</div>

                                        <div class="price">
                                            {{ 'PRICING.MANAGEMENT_PRICE' | translate }}
                                        </div>
                                        <p class="description">{{'PRICING.MANAGEMENT_PROPERO_TEXT' | translate }}</p>
                                    </div>
                                    <div class="card-body">
                                        <div class="title_black">
                                            {{'PRICING.MANAGEMENT_PROPERO_ITEM_TITLE' | translate }}
                                        </div>
                                        <div class="feature_black">
                                            {{'PRICING.MANAGEMENT_PROPERO_ITEM_FEATURE' | translate }}
                                        </div>
                                        <ul class="features-list">
                                            <li><i class="fas fa-check"></i>
                                                {{'PRICING.MANAGEMENT_PROPERO_FUNCTIONALITY_1_TEXT' | translate }}</li>
                                            <li><i class="fas fa-check"></i>
                                                {{'PRICING.MANAGEMENT_PROPERO_FUNCTIONALITY_2_TEXT' | translate }}</li>
                                            <li><i class="fas fa-check"></i>
                                                {{'PRICING.MANAGEMENT_PROPERO_FUNCTIONALITY_3_TEXT' | translate }}</li>
                                            <li><i class="fas fa-check"></i>
                                                {{'PRICING.MANAGEMENT_PROPERO_FUNCTIONALITY_4_TEXT' | translate }}</li>
                                            <li><i class="fas fa-check"></i>
                                                {{'PRICING.MANAGEMENT_PROPERO_FUNCTIONALITY_5_TEXT' | translate }}</li>
                                            <li><i class="fas fa-check"></i>
                                                {{'PRICING.MANAGEMENT_PROPERO_FUNCTIONALITY_6_TEXT' | translate }}</li>
                                        </ul>
                                        <div class="notes_black">
                                            <p>{{'PRICING.MANAGEMENT_PROPERO_ITEM_NOTES_1' | translate }}</p>
                                            <p>{{'PRICING.MANAGEMENT_PROPERO_ITEM_NOTES_2' | translate }}</p>
                                        </div>
                                    </div>
                                    <div class="card-footer">
                                        <a href="/collaboration#contact"
                                            class="btn-premium">{{'PRICING.REQUEST_OFFER_BUTTON' | translate }}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-8">
                                <div class="features-table premium">
                                    <h4>{{'PRICING.MANAGEMENT_PROPERO_FUNCTIONALITY_TEXT' | translate }}</h4>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <tbody>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM1_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">Management Propero plan</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM2_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM3_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ENTERPRISE_ENTERPRISE'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM4_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ENTERPRISE'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM5_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ENTERPRISE'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM6_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ENTERPRISE_ENTERPRISE'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM7_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_X_1_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ENTERPRISE'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_X_2_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ENTERPRISE'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_X_3_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ENTERPRISE'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM10_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ENTERPRISE_ENTERPRISE'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_NOT_1_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_NOT_2_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM_NOT_3_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM12_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ENTERPRISE_ENTERPRISE'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM13_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM14_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM16_TEXT' | translate }}</td>
                                                    <td><span
                                                            class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                            | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM17_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM18_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM20_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM21_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM22_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM24_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ENTERPRISE'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM25_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ENTERPRISE'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM27_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">
                                                            {{'PRICING.FUNCTIONALITY_OPTION_PREMIUM'
                                                            | translate }}
                                                        </span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM29_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ENTERPRISE_ENTERPRISE'
                                                        | translate }}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM30_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">{{'PRICING.FUNCTIONALITY_OPTION_ENTERPRISE_ENTERPRISE'
                                                        | translate }}</span></td>
                                                </tr>

                                                <tr>
                                                    <td>{{'PRICING.PLAN_ITEM32_TEXT' | translate }}</td>
                                                    <td><span class="feature-value">
                                                            <span class="feature-value">
                                                                Management Propero
                                                            </span>
                                                        </span></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="about-area">
    <div class="container">
        <div class="row justify-content-center">

            <div class="col-lg-10 col-md-10">
                <div class="about-title">
                    <h6 class="sub-title">{{ 'PRICING.ADDITIONAL_DETAILS' | translate }}</h6>
                    <h4 class="title">{{ 'PRICING.FAQ' | translate }}</h4>
                </div>
                <div class="about-accordion">
                    <div class="accordion" id="accordionExample">
                        <div class="card">
                            <div class="card-header" id="headingOne">
                                <a i18n="@@question1Text" href="#" class="collapsed" data-toggle="collapse"
                                    data-target="#collapseOne" aria-expanded="false"
                                    aria-controls="collapseOne">{{'PRICING.QUESTION1' | translate }}</a>
                            </div>
                            <div id="collapseOne" class="collapse" aria-labelledby="headingOne"
                                data-parent="#accordionExample">
                                <div class="card-body">
                                    <p i18n="@@question1Answer" class="text">{{'PRICING.Q_ANSWER1' | translate }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="headingThree">
                                <a i18n="@@question2Text" href="#" class="collapsed" data-toggle="collapse"
                                    data-target="#collapseThree" aria-expanded="false"
                                    aria-controls="collapseThree">{{'PRICING.QUESTION2' | translate }}</a>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                                data-parent="#accordionExample">
                                <div class="card-body">
                                    <p i18n="@@question2Answer" class="text">{{'PRICING.Q_ANSWER2' | translate }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="contact" class="contact-area white-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-10">
                <div class="section-title text-center pb-30">
                    <h3 class="title">{{ 'HOME.SECTION_CONTACTUS_TITLE' | translate }}</h3>
                    <p class="text">{{ 'HOME.SECTION_CONTACTUS_TEXT' | translate }}</p>
                </div>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="contact-wrapper">
                    <h4 class="contact-title">
                        <i class="lni lni-envelope"></i>
                        {{ 'HOME.TEXT_MESSAGE' | translate }}
                    </h4>
                    <form #contactForm="ngForm" (ngSubmit)="send()">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-input">
                                    <label>{{ 'PRICING.NAME' | translate }}</label>
                                    <div class="input-items">
                                        <input type="text" name="name" placeholder="{{ 'PRICING.NAME' | translate }}"
                                            [(ngModel)]="contactItem.subject" required>
                                        <i class="lni lni-user"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-input">
                                    <label>{{ 'PRICING.EMAIL' | translate }}</label>
                                    <div class="input-items">
                                        <input type="email" name="email" placeholder="{{ 'PRICING.EMAIL' | translate }}"
                                            [(ngModel)]="contactItem.email" required email>
                                        <i class="lni lni-envelope"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-input">
                                    <label>{{ 'PRICING.MESSAGE' | translate }}</label>
                                    <div class="input-items textarea">
                                        <textarea name="message" placeholder="{{ 'PRICING.MESSAGE' | translate }}"
                                            [(ngModel)]="contactItem.content" required></textarea>
                                        <i class="lni lni-pencil-alt"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="text-center">
                                    <button 
                                        type="submit"
                                        class="features-btn" 
                                        [disabled]="contactForm.invalid || isLoading"
                                        [ngClass]="{'loading': isLoading}"
                                    >
                                        <span *ngIf="!isLoading">{{ 'PRICING.SEND' | translate }}</span>
                                        <span *ngIf="isLoading">{{ 'PRICING.SENDING' | translate }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>